<template>
  <div>
    <brand-listing v-for="entry in dictionary" :key="entry[0]" :entry="entry"></brand-listing>
  </div>
</template>

<script>
import BrandListing from "./BrandListing";

export default {
  name: "BrandListings",
  components: {
    BrandListing,
  },
  props: {
    dictionary: {
      type: Array,
      required: true,
    },
  },
};
</script>
